// Suggested Customer List updates (Pat, Oct 6 2026: "update address, phone numbers and fax
// numbers from the internet — ask to confirm each before inputting"). Looked up on the web on
// Oct 6 2026 against the list as it stood Sep 9. Nothing here is applied by itself: the
// Clients / GCs page shows each one beside what's in the list now, and only what's ticked and
// applied is saved. Entries with nothing new to suggest carry just their note.
const CUSTOMER_SUGGESTIONS = [
 {
  "client_id": "2ef847fcbbdc794e288fa851",
  "name": "Briggs Electric",
  "suggest": {
   "address1": "5111 Convair Drive",
   "address2": "Carson City, NV 89706",
   "phone": "(775) 887-9901"
  },
  "confidence": "medium",
  "note": "Nevada office of Briggs Electric, Inc. (head office Tustin, CA, (714) 544-2500). No fax published.",
  "sources": [
   "https://www.briggselectric.com/"
  ]
 },
 {
  "client_id": "a84634916b1cac4e64d2648c",
  "name": "Capriati Construction",
  "suggest": {
   "fax": "(702) 547-0598"
  },
  "confidence": "high",
  "note": "Matches what's on file; fax from the company's own contact page.",
  "sources": [
   "https://www.capriaticonstruction.com/contact-us/"
  ]
 },
 {
  "client_id": "8f17082fd104e93dc3ecadea",
  "name": "City of Yerington",
  "suggest": {
   "address1": "14 E. Goldfield Avenue",
   "address2": "Yerington, NV 89447"
  },
  "confidence": "high",
  "note": "City Hall. Phone matches. No fax published.",
  "sources": [
   "https://www.yerington.net/"
  ]
 },
 {
  "client_id": "5f19326bc8cdf5a6b6cdfd0d",
  "name": "Garden Shop Landscaping",
  "suggest": {
   "address1": "485 Western Rd.",
   "address2": "Reno, NV 89506",
   "phone": "(775) 358-3080",
   "fax": "(775) 358-3084"
  },
  "confidence": "high",
  "note": "Commercial landscape contractor in Northern Nevada since 1986.",
  "sources": [
   "https://www.gardenshoplandscaping.com/"
  ]
 },
 {
  "client_id": "1eb5c44dabb6beeb838cb73d",
  "name": "Maple Creek Construction",
  "suggest": {
   "address1": "600 S. Arlington Ave"
  },
  "confidence": "medium",
  "note": "Matches what's on file ('Suite 100' not confirmed). Its Nevada license shows expired (2015) on BuildZoom — worth checking.",
  "sources": [
   "https://www.linkedin.com/company/maple-creek-construction-nv"
  ]
 },
 {
  "client_id": "93a921ce1d332162799fa6c3",
  "name": "Nevada State Public Works",
  "suggest": {
   "address1": "680 W. Nye Lane, Suite 103",
   "address2": "Carson City, NV 89703",
   "phone": "(775) 684-4141",
   "fax": "(775) 684-4142"
  },
  "confidence": "high",
  "note": "State Public Works Division, Carson City office. Las Vegas office: 7115 Amigo St., Suite 100, (702) 486-5115.",
  "sources": [
   "https://publicworks.nv.gov/Contact/Contact/"
  ]
 },
 {
  "client_id": "a237a7e5054f80fb51266211",
  "name": "Qualcom Contractors, Inv",
  "suggest": {
   "address1": "1645 Esmeralda Ave",
   "address2": "Minden, NV 89423",
   "phone": "(775) 782-2006",
   "fax": "(775) 782-3226",
   "name": "Qualcon Contractors, Inc."
  },
  "confidence": "medium",
  "note": "The name on file looks mistyped — the company is Qualcon Contractors, Inc. of Minden (general engineering contractor since 1982).",
  "sources": [
   "https://www.bbb.org/us/nv/minden/profile/general-engineering-contractor/qualcon-contractors-inc-1166-10005041"
  ]
 },
 {
  "client_id": "60a16f213fdfc191c0a3c046",
  "name": "Reno-Tahoe Airport Authority",
  "suggest": {
   "address1": "P.O. Box 12490",
   "address2": "Reno, NV 89510-2490",
   "phone": "(775) 328-6400"
  },
  "confidence": "high",
  "note": "The address on file is an email (DDorado@renoairport.com) — that belongs on a contact. (775) 690-0048 on file is probably that person's direct line. Physical address: 2001 E. Plumb Lane, Reno 89502. Same organization as the 'Reno Tahoe International Airport' customer (likely a duplicate).",
  "sources": [
   "https://www.renoairport.com/contact-us/"
  ]
 },
 {
  "client_id": "525ad9142d79b589231ced19",
  "name": "TRUCKEE RIVER FLOOD MANAGEMENT AUTHORITY",
  "suggest": {
   "address1": "9635 Gateway Drive, Suite A",
   "address2": "Reno, NV 89521",
   "phone": "(775) 850-7473"
  },
  "confidence": "high",
  "note": "From TRFMA's own contact page.",
  "sources": [
   "https://www.trfma.org/contact-us"
  ]
 },
 {
  "client_id": "20f363c6f87c5b71d0e51499",
  "name": "Toll Brothers",
  "suggest": {
   "address1": "1140 Virginia Drive",
   "address2": "Fort Washington, PA 19034",
   "phone": "(215) 938-8000"
  },
  "confidence": "low",
  "note": "Corporate HQ only — no Reno office address is published. Nevada sales line (855) 400-8655. Better to ask your Toll contact for the Reno division office.",
  "sources": [
   "https://www.tollbrothers.com/luxury-homes/Reno-NV"
  ]
 },
 {
  "client_id": "98bea691dfc3a8cf66a6a725",
  "name": "United States Department of Agriculture Forest Service",
  "suggest": {
   "address1": "1536 South Carson Street",
   "address2": "Carson City, NV 89701",
   "phone": "(775) 882-2766"
  },
  "confidence": "medium",
  "note": "Humboldt-Toiyabe National Forest, Carson Ranger District — nearest office to Reno. Lake Tahoe Basin jobs go through a different office.",
  "sources": [
   "https://www.fs.usda.gov/r04/humboldt-toiyabe/offices/carson-ranger-district"
  ]
 },
 {
  "client_id": "0ce1eeb845cdd962beebf083",
  "name": "Caltrans",
  "suggest": {
   "address1": "703 B Street",
   "address2": "Marysville, CA 95901",
   "phone": "(530) 741-4572"
  },
  "confidence": "high",
  "note": "District 3 office (covers Truckee/Tahoe/I-80). No fax published. Use a different district's office if a job was in another district.",
  "sources": [
   "https://dot.ca.gov/caltrans-near-me/district-3/d3-popular-links/d3-about"
  ]
 },
 {
  "client_id": "64d9e2b4908d42c179aee783",
  "name": "Carson City",
  "suggest": {
   "fax": "(775) 887-2112"
  },
  "confidence": "high",
  "note": "Carson City Public Works. Address and phone on file match. Fax from the city's Public Works page as shown in search results.",
  "sources": [
   "https://carson.org/government/departments-g-z/public-works"
  ]
 },
 {
  "client_id": "d22b74bc6288c4f9f486e2c8",
  "name": "Cruz Construction Co.",
  "suggest": {
   "address1": "19 Cygnet Dr",
   "address2": "Mound House, NV 89706",
   "phone": "(775) 883-6161"
  },
  "confidence": "medium",
  "note": "Cruz Construction Co., Inc. of Mound House, a paving and grading contractor. From a business directory; no company website found. No fax published.",
  "sources": [
   "https://data.facturmfg.com/company/cruz-construction-co-inc-659db5e0de60709c1bbfdf7f"
  ]
 },
 {
  "client_id": "985de7c5f67152f15a28199e",
  "name": "Glass Roots Construction",
  "suggest": {
   "phone": "(720) 704-8451"
  },
  "confidence": "low",
  "note": "Fiber/telecom builder described as Reno-based; no street address published. The phone on its website is a Colorado (720) number, probably head office. Email info@glassrootsconstruction.com.",
  "sources": [
   "https://www.glassrootsconstruction.com/"
  ]
 },
 {
  "client_id": "4214b5a6e385aa650c573803",
  "name": "KP Construction",
  "suggest": {
   "address1": "924 Incline Way",
   "address2": "Incline Village, NV 89451"
  },
  "confidence": "medium",
  "note": "The phone on file matches. The address on file (5401 Longley Lane Bldg B Suite 42) looks wrong — online it belongs to Permian Builders. This address is from KP's Nevada license record. Procore lists P.O. Box 19912, Reno.",
  "sources": [
   "https://www.buildzoom.com/contractor/kp-construction-llc-reno-nv",
   "https://network.procore.com/p/kp-construction-reno"
  ]
 },
 {
  "client_id": "c91d8fe4172ca44d0f8f09bc",
  "name": "NDOT",
  "suggest": {
   "address1": "310 Galletti Way",
   "address2": "Sparks, NV 89431",
   "phone": "(775) 834-8300",
   "fax": "(775) 834-8390"
  },
  "confidence": "high",
  "note": "District 2 office (Reno/Sparks). Head office: 1263 South Stewart Street, Carson City, NV 89712, (775) 888-7000, fax (775) 888-7115.",
  "sources": [
   "https://www.dot.nv.gov/doing-business/contact-us"
  ]
 },
 {
  "client_id": "c660b46969f65d1b1f3501fd",
  "name": "Ormat Technologies",
  "suggest": {
   "address1": "6884 Sierra Center Parkway",
   "address2": "Reno, NV 89511",
   "phone": "(775) 356-9029",
   "fax": "(775) 356-9039"
  },
  "confidence": "high",
  "note": "Corporate headquarters in Reno. The fax is from directories and an older (2006) announcement — likely still right, but older.",
  "sources": [
   "https://www.globaldata.com/company-profile/ormat-technologies-inc/locations/"
  ]
 },
 {
  "client_id": "b18e1090e80a7b1887595ab6",
  "name": "RK Contractors",
  "suggest": {
   "address2": "Verdi, NV 89439",
   "phone": "(775) 622-1809"
  },
  "confidence": "medium",
  "note": "Excavation/underground contractor in the Truckee/Reno area. Website gives only 'Verdi, NV', no street. Email info@rkcontractorsinc.com.",
  "sources": [
   "https://www.rkcontractorsinc.com/"
  ]
 },
 {
  "client_id": "fe038821750a4cdb1c05f9d7",
  "name": "Rolcom Corporation",
  "suggest": {
   "address1": "240 Ott Street",
   "address2": "Corona, CA 92880",
   "phone": "(951) 278-1040"
  },
  "confidence": "low",
  "note": "California electrical contractor; Corona head office from its license record, which shows the license expired June 30, 2026. No Nevada office found. Check this is the right Rolcom.",
  "sources": [
   "https://levelset.com/contractors/rolcom-corporation/about"
  ]
 },
 {
  "client_id": "a845e6076a0a222e7e4d5214",
  "name": "Tahoe Transportation District",
  "suggest": {
   "address1": "128 Market Street, Suite 3F",
   "address2": "Stateline, NV 89449",
   "phone": "(775) 589-5500",
   "fax": "(775) 588-0917"
  },
  "confidence": "high",
  "note": "Office address. Their mailing address for invoices is P.O. Box 499, Zephyr Cove, NV 89448. Fax from a transit industry directory.",
  "sources": [
   "https://tahoetransportation.org/"
  ]
 },
 {
  "client_id": "1556fb3baf42758f503d4699",
  "name": "Tahoe Transportation District",
  "suggest": {
   "address1": "128 Market Street, Suite 3F",
   "address2": "Stateline, NV 89449",
   "phone": "(775) 589-5500",
   "fax": "(775) 588-0917"
  },
  "confidence": "high",
  "note": "Office address. Their mailing address for invoices is P.O. Box 499, Zephyr Cove, NV 89448. Fax from a transit industry directory.",
  "sources": [
   "https://tahoetransportation.org/"
  ]
 },
 {
  "client_id": "47ba655ed9d89f3640f98b7a",
  "name": "Town of Truckee",
  "suggest": {
   "address1": "10183 Truckee Airport Road",
   "address2": "Truckee, CA 96161",
   "phone": "(530) 582-7700",
   "fax": "(530) 582-7710"
  },
  "confidence": "high",
  "note": "Town Hall.",
  "sources": [
   "https://townoftruckee.gov/directory.aspx?did=22"
  ]
 },
 {
  "client_id": "b80ab32ad037ec982c989814",
  "name": "Wasatch Electric",
  "suggest": {
   "address1": "9128 S Jones Ranch Drive",
   "address2": "West Jordan, UT 84081",
   "phone": "(801) 487-4511"
  },
  "confidence": "medium",
  "note": "Utah head office (recently moved here); no Nevada office found.",
  "sources": [
   "https://www.wasatchelectric.com/"
  ]
 },
 {
  "client_id": "f30479e8ad7fee754ebdc42c",
  "name": "Atlas Construction",
  "suggest": {
   "address1": "1475 Hulda Way",
   "address2": "Sparks, NV 89431"
  },
  "confidence": "medium",
  "note": "Really Atlas Contractors, Inc. in Sparks; the phone and fax on file match it. Street address from one directory; another lists 3805 Boulder Patch, Reno 89511. Its Nevada license showed as expired (2014) — check it is still active.",
  "sources": [
   "https://www.homeyou.com/atlas-contractors-inc-sparks-nv"
  ]
 },
 {
  "client_id": "016e53bfc313170211c98d32",
  "name": "City Of Sparks",
  "suggest": {
   "address2": "Sparks, NV 89431",
   "phone": "(775) 353-5555",
   "fax": "(775) 353-2399"
  },
  "confidence": "medium",
  "note": "City Hall. The street address ZIP is 89431 (89432 on file is the PO Box ZIP). Main number is 353-5555; 353-7809 on file is probably a department line. The fax is from a bid document and its department is unclear.",
  "sources": [
   "https://sparksnv.gov/"
  ]
 },
 {
  "client_id": "2967b309148a4c980ec78efb",
  "name": "Eleven Western Builders",
  "suggest": {
   "phone": "(760) 796-6346"
  },
  "confidence": "high",
  "note": "Escondido headquarters matches the file. Main number is (760) 796-6346; the (760) 546-4951 on file may be a direct line. Nearest office: 269 Technology Way, Ste. B-7, Rocklin, CA 95765, (916) 408-6950.",
  "sources": [
   "https://www.elevenwestern.com/contact"
  ]
 },
 {
  "client_id": "809eb40ed64a90a8ded73541",
  "name": "Holder",
  "suggest": {
   "address1": "2099 Gateway Pl, Suite 340",
   "address2": "San Jose, CA 95110",
   "phone": "(408) 516-4401"
  },
  "confidence": "low",
  "note": "Assumed Holder Construction; no Nevada office, so the nearest West Coast office. Check against your contact's email signature.",
  "sources": [
   "https://www.holderconstruction.com/contact"
  ]
 },
 {
  "client_id": "9b29c9a2bcc24ef928a09915",
  "name": "MKD",
  "suggest": {
   "fax": "(775) 246-1986"
  },
  "confidence": "high",
  "note": "Address and phone match the file. Fax from the BBB listing. Mailing address: PO Box 22070, Carson City, NV 89721.",
  "sources": [
   "https://mkd-construction.com/contact/",
   "https://www.bbb.org/us/nv/mound-house/profile/general-contractor/mkd-construction-inc-1166-105802"
  ]
 },
 {
  "client_id": "78247f6c7ddcac31b3c42468",
  "name": "NV ENERGY",
  "suggest": {
   "address1": "6100 Neil Road",
   "address2": "Reno, NV 89511",
   "phone": "(775) 834-4444"
  },
  "confidence": "medium",
  "note": "Northern Nevada headquarters. 834-4444 is customer service; Business Solutions is (775) 473-6998. No official fax published.",
  "sources": [
   "https://www.nvenergy.com/contact-us"
  ]
 },
 {
  "client_id": "6dc6a404fe06e4a5f74947fd",
  "name": "POKRAJAC CORPORATION",
  "suggest": {
   "address1": "1953 N Warren Rd",
   "address2": "San Jacinto, CA 92582",
   "phone": "(951) 654-4494"
  },
  "confidence": "medium",
  "note": "Grading/paving contractor; yard/office per BBB. The (951) 712-4502 on file may be a person's direct line. State license gives 333 N Madison Ave, Monrovia, CA 91016.",
  "sources": [
   "https://www.bbb.org/us/ca/san-jacinto/profile/general-engineering-contractor/pokrajac-corporation-1126-89091118"
  ]
 },
 {
  "client_id": "b7b6d064bb43e36b523e6547",
  "name": "Regional Transportation Commision",
  "suggest": {
   "address1": "1105 Terminal Way",
   "address2": "Reno, NV 89502",
   "phone": "(775) 348-0400",
   "fax": "(775) 324-3503",
   "name": "Regional Transportation Commission"
  },
  "confidence": "high",
  "note": "RTC of Washoe County main office. Engineering (775) 348-0171. Name typo on file: 'Commision' → 'Commission'.",
  "sources": [
   "https://rtcwashoe.com/about/contact-us"
  ]
 },
 {
  "client_id": "deb52013bd88e1333ba4bbc7",
  "name": "Sierra Dirt Works",
  "suggest": {
   "address1": "2208 Dickerson Rd",
   "address2": "Reno, NV 89503",
   "phone": "(775) 786-7744"
  },
  "confidence": "low",
  "note": "Two possible companies. The 150 Huffaker Pl address on file belongs to Sierra Earthworks LLC. The (775) 345-4733 on file didn't show up online. Check which company it is.",
  "sources": [
   "https://excavation-contractors.cmac.ws/sierra-dirt-works/15594/"
  ]
 },
 {
  "client_id": "29a188760e1af013da8a1565",
  "name": "Truckee Meadows Water Authority",
  "suggest": {
   "address1": "1355 Capital Blvd",
   "address2": "Reno, NV 89502",
   "phone": "(775) 834-8080"
  },
  "confidence": "medium",
  "note": "Main office / customer service. Mailing: P.O. Box 30013, Reno, NV 89520-3013. No fax confirmed.",
  "sources": [
   "https://tmwa.com/contact/"
  ]
 },
 {
  "client_id": "8978f7e263c855fb61826c8a",
  "name": "Washoe County",
  "suggest": {
   "address1": "1001 E. Ninth Street",
   "address2": "Reno, NV 89512",
   "phone": "(775) 328-2003",
   "fax": "(775) 328-6133"
  },
  "confidence": "medium",
  "note": "County Administrative Complex. The fax is the Community Services Department's (engineering/capital projects; phone (775) 328-3600) — the county has no general fax.",
  "sources": [
   "https://www.washoecounty.gov/mgrsoff/",
   "https://www.washoecounty.gov/csd/index.php"
  ]
 },
 {
  "client_id": "73c9ed00232c67ad260768e0",
  "name": "Barrick Mining Corporation",
  "suggest": {
   "address1": "1655 Mountain City Hwy",
   "address2": "Elko, NV 89801",
   "phone": "(775) 748-1001"
  },
  "confidence": "medium",
  "note": "Barrick's Elko office (Nevada Gold Mines uses the same address). Also a Henderson office: 2270 Corporate Circle, Suite 100, Henderson, NV 89074, (702) 522-6900.",
  "sources": [
   "https://www.barrick.com/English/about/contact-us/default.aspx"
  ]
 },
 {
  "client_id": "bca5db6738976493c2eb6b94",
  "name": "City of Reno",
  "suggest": {
   "address1": "1 E 1st Street",
   "phone": "(775) 334-4636"
  },
  "confidence": "high",
  "note": "City Hall; main number is Reno Direct 334-INFO. The 334-2548 on file is one Housing & Neighborhood Development analyst's direct line, and Suite 800 is that department's floor — fine if that's who you deal with.",
  "sources": [
   "https://www.reno.gov/government/contact-directions"
  ]
 },
 {
  "client_id": "425ef0ebd6e0b51d92940de0",
  "name": "Madole Construction",
  "suggest": {
   "address1": "18300 Joy Lake Rd",
   "address2": "Washoe Valley, NV 89704",
   "phone": "(775) 737-4414"
  },
  "confidence": "medium",
  "note": "Only Madole Construction found in Nevada. Mailing address PO Box 893, Sparks, NV 89432. Phones disagree between listings ((775) 372-3273 also seen).",
  "sources": [
   "https://www.levelset.com/contractors/madole-construction/about/"
  ]
 },
 {
  "client_id": "7563e1e03dfb3c0b1b8c4214",
  "name": "Nevada Department of Transportation",
  "suggest": {
   "address1": "310 Galletti Way",
   "address2": "Sparks, NV 89431",
   "phone": "(775) 834-8300",
   "fax": "(775) 834-8390"
  },
  "confidence": "high",
  "note": "District 2 office — same as the 'NDOT' customer (likely a duplicate). Carson City HQ: 1263 S Stewart St, (775) 888-7000, fax (775) 888-7115.",
  "sources": [
   "https://www.dot.nv.gov/doing-business/contact-us"
  ]
 },
 {
  "client_id": "a1bf4663175aa3e38d5cad87",
  "name": "Peek Brothers Construction",
  "suggest": {
   "address1": "2082 Resource Dr",
   "address2": "Fernley, NV 89408",
   "phone": "(775) 835-6472"
  },
  "confidence": "medium",
  "note": "Grading/underground/paving contractor. A second Fernley address (400 Carroll Dr) also appears.",
  "sources": [
   "https://www.levelset.com/contractors/peek-brothers-construction/about"
  ]
 },
 {
  "client_id": "f07a952f8b3cbbbafff0278f",
  "name": "Reno Tahoe International Airport",
  "suggest": {
   "address1": "2001 E Plumb Ln",
   "address2": "Reno, NV 89502",
   "phone": "(775) 328-6400"
  },
  "confidence": "high",
  "note": "Physical address. Mail goes to Reno-Tahoe Airport Authority, P.O. Box 12490, Reno, NV 89510-2490. Same organization as the 'Reno-Tahoe Airport Authority' customer (likely a duplicate).",
  "sources": [
   "https://www.renoairport.com/contact-us/"
  ]
 },
 {
  "client_id": "294580a1803046638a7234a4",
  "name": "Sierra Nevada Construction Inc",
  "suggest": {
   "fax": "(775) 355-0535"
  },
  "confidence": "high",
  "note": "Address and phone on file are right (drops a stray comma). Fax from City of Sparks bid plan-holder lists. Mailing: P.O. Box 50760, Sparks, NV 89435.",
  "sources": [
   "https://portal.cityofsparks.us/bids/bid/detail/275"
  ]
 },
 {
  "client_id": "aa1a6dd69b526344e2b502ea",
  "name": "Tesla",
  "suggest": {
   "address1": "1 Electric Ave",
   "address2": "Sparks, NV 89434",
   "phone": "(877) 798-3752"
  },
  "confidence": "medium",
  "note": "Gigafactory Nevada. No public plant phone — the number is Tesla's general line. For billing, ask your Tesla project contact for the site/AP address.",
  "sources": [
   "https://www.tesla.com/contact"
  ]
 },
 {
  "client_id": "b368a3ba39b02049ef5a670c",
  "name": "United States Air Force",
  "suggest": {
   "address1": "1776 National Guard Way",
   "address2": "Reno, NV 89502",
   "phone": "(775) 788-4515"
  },
  "confidence": "low",
  "note": "Most likely the 152nd Airlift Wing, Nevada Air National Guard (at the Reno airport). The phone is their Public Affairs line. Confirm from the job paperwork.",
  "sources": [
   "https://www.152aw.ang.af.mil/Contact/"
  ]
 },
 {
  "client_id": "6990b8db4575587aa763029a",
  "name": "White Rock Construction",
  "suggest": {
   "address1": "2365 Kaska St",
   "address2": "South Lake Tahoe, CA 96150"
  },
  "confidence": "low",
  "note": "No White Rock Construction found in Nevada; the closest match is a South Lake Tahoe contractor. Confirm before using.",
  "sources": [
   "https://www.levelset.com/contractors/white-rock-construction-ca/about"
  ]
 },
 {
  "client_id": "2ef15bb0b36768cfb5555575",
  "name": "Ames Construction",
  "suggest": {},
  "confidence": "low",
  "note": "Couldn't confirm a Reno office; 639 Isbell Road on file is unconfirmed. Possible Nevada office: 1705 Peru Dr, Sparks, NV 89437 (no phone). HQ Burnsville MN, (952) 435-7106. Ask Ames for its Reno office.",
  "sources": [
   "https://levelset.com/contractors/ames-construction/about"
  ]
 },
 {
  "client_id": "fecdb58d7e73601635c48a14",
  "name": "JC Plateau, LLC",
  "suggest": {},
  "confidence": "low",
  "note": "No public listing found; couldn't check what's on file. Keep it.",
  "sources": []
 },
 {
  "client_id": "0461934a17ffed140c2fc2a4",
  "name": "Aspen Developers",
  "suggest": {},
  "confidence": "low",
  "note": "Nothing found online for a company called 'Aspen Developers' in Reno. Couldn't confirm the address or phone on file, but nothing contradicts them either. Keep what's on file.",
  "sources": []
 },
 {
  "client_id": "997724083f0f28ec46792c22",
  "name": "Campbell Construction Company",
  "suggest": {},
  "confidence": "high",
  "note": "Matches what is on file. No fax published.",
  "sources": [
   "http://www.campbellcci.com/"
  ]
 },
 {
  "client_id": "5f534166584724732e574ec5",
  "name": "Campbell Development",
  "suggest": {},
  "confidence": "low",
  "note": "Couldn't confirm what's on file — the Glendale address is an executive-suites building. Other companies by this name exist (Phoenix AZ; El Dorado Hills CA). Keep what's on file.",
  "sources": []
 },
 {
  "client_id": "2a485e31ac67c6cae01a771e",
  "name": "F.W. Carson Co.",
  "suggest": {},
  "confidence": "medium",
  "note": "Matches what's on file. No fax published.",
  "sources": [
   "https://www.constructionbidsource.com/archives/ads/18099"
  ]
 },
 {
  "client_id": "84fe864be7e9a45161f9285b",
  "name": "Impact Construction",
  "suggest": {},
  "confidence": "medium",
  "note": "Matches what's on file. Physical office: 1650 Lucerne St Ste 202, Minden, NV 89423. No fax published.",
  "sources": [
   "https://levelset.com/contractors/impact-construction-nv/about"
  ]
 }
];
export default CUSTOMER_SUGGESTIONS;
